import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  INVENTORY_CART_CHANGED_EVENT,
  clearAllCartLines,
  incrementLine,
  lineQty,
  readCartLines,
  setLineQty,
  totalCartQuantity,
} from '@/lib/inventoryCart'

export function useInventoryCart() {
  const [version, setVersion] = useState(0)

  useEffect(() => {
    const onChange = () => setVersion((v) => v + 1)
    window.addEventListener(INVENTORY_CART_CHANGED_EVENT, onChange)
    return () => window.removeEventListener(INVENTORY_CART_CHANGED_EVENT, onChange)
  }, [])

  const lines = useMemo(() => readCartLines(), [version])

  const getQty = useCallback((inventoryId: string) => lineQty(inventoryId, lines), [lines])

  const addOne = useCallback((inventoryId: string, maxStock?: number | null) => {
    incrementLine(inventoryId, maxStock)
  }, [])

  const setQty = useCallback((inventoryId: string, qty: number, maxStock?: number | null) => {
    setLineQty(inventoryId, qty, maxStock)
  }, [])

  const removeOne = useCallback((inventoryId: string) => {
    const cur = lineQty(inventoryId, readCartLines())
    if (cur <= 0) return
    setLineQty(inventoryId, cur - 1, null)
  }, [])

  const clearAll = useCallback(() => {
    clearAllCartLines()
  }, [])

  const totalQty = useMemo(() => totalCartQuantity(lines), [lines])

  return { lines, getQty, addOne, removeOne, setQty, clearAll, totalQty }
}
